<template>
  <div class="bg-tealgray650 pt-3 pt-xl-5 pb-3 pb-xl-0">
    <b-container>
      <div class="d-sm-flex justify-content-between align-items-end pb-3">
        <!-- Logo Section -->
        <div v-if="$route.name === 'Main'" class="cursor" style="max-width: 200px">
          <b-img src="/static_img/logos/QESG_flat-v3.svg" style="max-height: 33.6px" />
        </div>
        <div v-else class="d-flex align-items-end justify-content-between">
          <div variant="icon" class="cursor" style="max-width: 200px" @click="goToMain">
            <b-img src="/static_img/logos/QESG_flat-v3.svg" style="max-height: 33.6px" />
          </div>
          <h4
            v-if="show_landing_menu !== true && report_code !== ''"
            class="mb-0 pl-1 pl-xl-2 d-none d-xl-inline fw-400 gray-400"
          >
            <template v-if="hasReportInfo">
              {{ selected_report.report_name }}
              <b-badge v-if="selected_report.sample_report" variant="info" class="mr-2"
                >sample</b-badge
              >
              <b-badge v-if="is_admin === 4">
                {{ selected_report.report_code }}
              </b-badge>
              <b-icon
                v-if="isEditPermitted"
                scale="1"
                class="ml-2"
                variant="success"
                icon="check-circle"
                aria-hidden="true"
              />
              <b-icon
                v-else
                v-b-tooltip.hover="readOnlyTooltip"
                class="ml-2"
                variant="danger"
                icon="x-circle"
                aria-hidden="true"
              />
            </template>
            <template v-else>
              <span class="ml-1 text-warning">
                <b-icon icon="exclamation-triangle-fill" class="mr-1" />
                <span class="fw-500">{{ noPermissionTitle }}</span>
              </span>
              <b-button size="sm" variant="outline-light" class="ml-2 py-0 px-2" @click="goToMain">
                <b-icon icon="arrow-left" class="mr-1" />보고서 목록으로
              </b-button>
            </template>
          </h4>
        </div>

        <!-- User Information and Actions -->
        <div class="d-flex justify-content-end">
          <div class="d-none d-xl-block">
            <div
              v-if="
                licenseInfo &&
                licenseInfo.available_report_cnt_info &&
                show_landing_menu &&
                $route.name === 'Main'
              "
              v-b-tooltip.hover
              class="py-1 px-2 mr-2 center"
              style="color: white; font-size: 0.9rem; width: fit-content"
              :title="`${licenseInfo?.service_info?.product_name} 플랜 이용 중`"
            >
              안녕하세요 {{ user_name }}님
              {{ licenseInfo.available_report_cnt_info.remain_report_cnt }}개 보고서를 추가로 생성할
              수 있습니다.
            </div>

            <div
              v-else-if="licenseInfo === null && show_landing_menu && $route.name === 'Main'"
              class="py-1 px-2 mr-2 center"
              style="color: white; font-size: 0.9rem; width: fit-content"
            >
              안녕하세요 {{ user_name }}님.
              <router-link to="/payment_service"> 결제 </router-link>후 보고서 생성이 가능합니다.
            </div>
          </div>

          <!-- Action Buttons -->
          <b-button
            id="bell"
            v-b-tooltip.hover
            variant="half-bg-light"
            class="py-1 px-2"
            aria-controls="notice-sidebar"
            title="공지 및 로그"
            @click="$emit('toggle-notice-sidebar')"
          >
            <fa id="bell" :icon="['far', 'bell']" />
            <div v-if="new_notice" class="notice-badge">
              {{ new_notice > 99 ? '99+' : new_notice }}
            </div>
          </b-button>
          <b-button
            id="my-info"
            :variant="is_confirmed ? 'half-bg-light' : 'red'"
            class="py-1 px-2 ml-2"
            @click.stop="$emit('show-my-info')"
          >
            <fa :icon="['far', 'user']" />
          </b-button>
          <b-button
            id="my-payment"
            v-b-tooltip.hover
            :variant="payment_active ? 'light' : 'half-bg-light'"
            class="py-1 px-2 ml-2"
            title="결제 정보"
            @click.stop="$router.push({ name: 'PaymentService' })"
          >
            <b-icon icon="credit-card" />
          </b-button>
          <b-dropdown
            id="manual-dropdown"
            v-model="manual_active"
            v-b-tooltip.hover
            :variant="manual_active ? 'light' : 'half-bg-light'"
            toggle-class="py-1 px-2 ml-2"
            no-caret
            title="매뉴얼"
            right
          >
            <template #button-content>
              <b-icon icon="list-ul" />
            </template>
            <b-dropdown-item
              v-for="item in filteredManualItems"
              :key="item.text"
              :href="item.link"
              target="_blank"
            >
              {{ item.text }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            v-if="is_admin === 4"
            variant="icon-light"
            class="py-1 px-2 ml-2"
            @click="$router.push({ name: 'AllReports' })"
          >
            관리자
          </b-button>
          <b-button variant="icon-light" class="py-1 px-2 ml-2" @click="logout">
            로그아웃
          </b-button>
        </div>
      </div>

      <!-- Mobile View -->
      <div class="d-block d-xl-none">
        <div
          v-if="
            licenseInfo &&
            licenseInfo.available_report_cnt_info &&
            show_landing_menu &&
            $route.name === 'Main'
          "
          v-b-tooltip.hover
          class="py-1 px-2 mr-2 center"
          style="color: white; font-size: 0.9rem; width: fit-content"
          :title="`${licenseInfo?.service_info?.product_name} 플랜 이용 중`"
        >
          안녕하세요 {{ user_name }}님
          {{ licenseInfo.available_report_cnt_info.remain_report_cnt }}개 보고서를 추가로 생성할 수
          있습니다.
        </div>

        <div
          v-else-if="licenseInfo === null && show_landing_menu && $route.name === 'Main'"
          class="py-1 px-2 mr-2 center"
          style="color: white; font-size: 0.9rem; width: fit-content"
        >
          안녕하세요 {{ user_name }}님. <router-link to="/payment_service"> 결제 </router-link>후
          보고서 생성이 가능합니다.
        </div>
      </div>

      <!-- Report Name for Mobile -->
      <h4
        v-if="$route.name !== 'Main' && !show_landing_menu && report_code !== ''"
        class="mb-2 mb-sm-0 pl-1 pl-xl-2 d-inline d-xl-none fw-400 gray-400"
      >
        <template v-if="hasReportInfo">
          <b-badge v-if="selected_report.sample_report" variant="info" class="mr-1">sample</b-badge>
          <b-badge v-if="is_admin === 4">
            {{ selected_report.report_code }}
          </b-badge>
          {{ selected_report.report_name }}
          <b-icon
            v-if="isEditPermitted"
            scale="1"
            variant="success"
            icon="check-circle"
            aria-hidden="true"
          />
          <b-icon
            v-else
            v-b-tooltip.hover="readOnlyTooltip"
            variant="danger"
            icon="x-circle"
            aria-hidden="true"
          />
        </template>
        <template v-else>
          <span class="text-warning">
            <b-icon icon="exclamation-triangle-fill" class="mr-1" />
            <span class="fw-500">{{ noPermissionTitle }}</span>
          </span>
          <b-button size="sm" variant="outline-light" class="ml-2 py-0 px-2" @click="goToMain">
            <b-icon icon="arrow-left" class="mr-1" />보고서 목록으로
          </b-button>
        </template>
      </h4>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LogAndNotice from './LogAndNotice';
import Notice from './Notice.js';
export default {
  name: 'TopHeader',
  components: {
    LogAndNotice
  },
  mixins: [Notice],
  props: {
    payment_active: { type: Boolean, default: false },
    manual_active: { type: Boolean, default: false },
    show_landing_menu: { type: Boolean, default: true }
  },
  data() {
    return {
      manualItems: [
        {
          text: '사용 매뉴얼',
          link: 'https://qesg.co.kr/docs/home/QESG_ESG_Reporting_Tool_Service_2026_v_1.pdf'
        },
        {
          text: '사용 가이드 (인터랙티브)',
          link: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
        },
        {
          text: '사용 가이드 (Gitbook)',
          link: 'https://quantifiedesg-inc.gitbook.io/esg-reporting-tool'
        },
        {
          text: '관리자용 설명서',
          link: 'https://www.notion.so/qesg/Q-A-1e477f7d74ca80b9b1b9d0c46e465570'
        }
      ]
    };
  },
  computed: {
    ...mapState(['user_id', 'is_confirmed', 'is_admin', 'user_name', 'licenseInfo', 'e_mail']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['report_code', 'standard_mode']),
    ...mapState('logs', ['activity_logs', 'activity_logs_loaded', 'new_notice', 'mention_list']),
    filteredManualItems() {
      return this.manualItems.filter(
        item => item.text !== '관리자용 설명서' || this.is_admin === 4
      );
    },
    // selected_report에 실제 보고서 데이터가 채워졌는지 (getter는 못 찾으면 {} 반환).
    // 관리자가 비-멤버 보고서에 진입하거나 세션 만료로 report_list가 비워졌을 때 false가 된다 (issue #855).
    hasReportInfo() {
      return !!(this.selected_report && this.selected_report.report_name);
    },
    // 권한 아이콘 분기: 관리자(is_admin === 4)는 모든 보고서에 대해 편집 권한이 있으므로
    // 백엔드가 is_able_to_edit=false로 내려주더라도 ✓ 아이콘을 노출한다 (issue #855).
    isEditPermitted() {
      if (this.is_admin === 4) return true;
      return !!(this.selected_report && this.selected_report.is_able_to_edit);
    },
    readOnlyTooltip() {
      return '읽기 권한만 있습니다. 세션이 만료된 경우 다시 로그인하시거나, 결제 후 편집 및 공개가 가능합니다.';
    },
    noPermissionTitle() {
      if (this.is_admin === 4) {
        return '보고서 정보를 불러오는 중입니다...';
      }
      return '이 보고서의 편집 권한이 없습니다.';
    }
  },
  methods: {
    ...mapActions(['logout']),
    ...mapActions('logs', ['readNoticesByUser']),
    ...mapActions('report_list', ['ensureReportLoadedForAdmin']),
    goToMain() {
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS1', true);
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS2', false);
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS3', false);
      this.$router.push({ name: 'Main' });
    },
    // 관리자가 비-멤버 보고서에 직접 진입(URL 직타, 새로고침 등)했을 때 selected_report가 빈 객체로
    // 남는 것을 막기 위해 ensureReportLoadedForAdmin을 호출한다 (issue #855).
    // 액션이 rootState.e_mail / user_id를 페이로드로 사용하므로 hydrate 이전(또는 비로그인)
    // 타이밍에 빈 user_id로 admin 검색 API가 호출되지 않도록 e_mail 가드를 둔다.
    maybeLoadAdminReport() {
      if (this.is_admin !== 4) return;
      if (!this.e_mail) return;
      if (!this.report_code) return;
      if (this.hasReportInfo) return;
      this.ensureReportLoadedForAdmin({ report_code: this.report_code });
    }
  },
  watch: {
    e_mail: {
      handler(newVal) {
        // e_mail이 설정되면 readNoticesByUser 호출
        if (newVal) {
          this.readNoticesByUser({ user_email: newVal });
          // 새로고침 직후 report_code는 hydrate되었지만 e_mail이 아직 비어 있을 수 있다.
          // maybeLoadAdminReport는 e_mail이 없으면 가드로 return되므로, e_mail이 채워진
          // 시점에 한 번 더 트리거해 비-멤버 보고서 정보 로드를 보장한다 (issue #855).
          this.maybeLoadAdminReport();
        }
      },
      immediate: true // 컴포넌트가 생성될 때도 즉시 실행
    },
    // report_code 변경 시 admin 권한이면 누락된 보고서 정보를 자동으로 채운다 (issue #855).
    report_code: {
      handler() {
        this.maybeLoadAdminReport();
      },
      immediate: true
    }
  },
  mounted() {
    // e_mail이 이미 있으면 호출, 없으면 watch가 처리
    if (this.e_mail) {
      this.readNoticesByUser({ user_email: this.e_mail });
    }
  }
};
</script>

<style scoped>
#bell {
  position: relative;
}
.notice-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  transform: translate(50%, -50%);
  background-color: #dc3545;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  text-align: center;
}
</style>
